import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ApplicationComponent} from '../application/application.component';
import {ApplicationConst} from './routingConst';
import {AuthGuard} from './authGuard';
import {NewPasswordComponent} from '../application/new-password/new-password.component';
import {DownloadDepositComponent} from '../application/download-deposit/download-deposit.component';
import {DownloadReportFileComponent} from '../application/download-report-file/download-report-file.component';
import {LoginComponent} from "../application/login/login.component";
import {LogoutComponent} from "../application/logout/logout.component";

/**
 * List of appRoutes
 * */
const appRoutes: Routes = [
  {path: '', component: ApplicationComponent},
  {path: ApplicationConst.uploadPath, component: ApplicationComponent, canActivate: [AuthGuard]},
  {path: ApplicationConst.resetPasswordPath, component: NewPasswordComponent},
  {path: ApplicationConst.downloadPath, component: DownloadDepositComponent},
  {path: ApplicationConst.downloadReport, component: DownloadReportFileComponent},
  {path: ApplicationConst.wso2Back, component:LoginComponent},
  {path: ApplicationConst.logout, component:LogoutComponent},
  {path: '**', redirectTo: '', pathMatch: 'full'}

];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes
    )
  ],
  exports: [
    RouterModule
  ]
})

export class AppRoutingModule {
}
